// require('babel-polyfill')
let $ = require('jquery')
import Vue from 'vue';

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.component('vue-test-modal', require('../components/vue-test-modal/vue-test-modal').default);

const app = new Vue({
  el: '#app',
  methods: {
    openTestModal: function() {
      this.$refs.testModal.openModal()
    }
  },
  mounted() {
    // console.log(this, this.$refs)
  }
});

$('.js-test-modal-trigger').click(function() {
  app.openTestModal()
});
